import React from "react";
import CreateLiveClassForm from "../components/CreateLiveClassForm";

const ScheduleClass = () => {
  return <CreateLiveClassForm />;
};

export default ScheduleClass;
